import { render } from "./MobileGuide.vue?vue&type=template&id=0b3fafdd&scoped=true"
import script from "./MobileGuide.vue?vue&type=script&lang=js"
export * from "./MobileGuide.vue?vue&type=script&lang=js"

import "./MobileGuide.vue?vue&type=style&index=0&id=0b3fafdd&scoped=true&lang=css"

import exportComponent from "/Users/iyongmin/Documents/twin-cosmos/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3fafdd"]])

export default __exports__